import React from 'react';
import { Table, UncontrolledTooltip } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../../../../shared/components';
import NumberFormatterSinSeparador from '../../NumberFormatterSinSeparador';
import { tooltipPreventOverflowModifiers } from '../../../../../../shared/misc/utils';

interface CalculatorTableWrapperProps {
  totalCarbonSum: number | null;
  onShowDetailsModal: () => void;
  colGroup?: React.ReactNode;
  children?: React.ReactNode;
  tableClassName?: string;
  subtotalLabel?: string;
  subtotalColSpan?: number;
}

const CalculatorTableWrapper: React.FC<CalculatorTableWrapperProps> = ({
  totalCarbonSum,
  onShowDetailsModal,
  colGroup,
  children,
  tableClassName = 'table--bordered action-padding-calculator',
  subtotalLabel = 'Subtotal',
  subtotalColSpan = 2,
}) => {
  const { t } = useTranslation();

  return (
    <div className="table-wrapper-calc-grid">
      <Table responsive className={tableClassName}>
        {colGroup}
        {children}
        {totalCarbonSum !== null && (
          <tfoot>
            <tr>
              <td className="subtotal-column-calculator" colSpan={subtotalColSpan}>
                <div>
                  {subtotalLabel}: <NumberFormatterSinSeparador value={totalCarbonSum} /> t CO
                  <sub>2</sub>
                </div>
              </td>
              <td className="action-column text-right">
                <Button
                  htmlId="tr-street-detail"
                  className="btn-tertiary no-padding action-calculator"
                  icon="clipboard-list"
                  text=""
                  onClick={onShowDetailsModal}
                />
                <UncontrolledTooltip
                  className="tooltip-toolkit"
                  placement="bottom"
                  target="tr-street-detail"
                  modifiers={tooltipPreventOverflowModifiers}
                >
                  {t('Details')}
                </UncontrolledTooltip>
              </td>
            </tr>
          </tfoot>
        )}
      </Table>
    </div>
  );
};

export default CalculatorTableWrapper;
